// extracted by mini-css-extract-plugin
export default {"makerLightGrey":"#e8e7e6","gameBoard":"games_gameBoard__EK+1O","items":"games_items__o0+E5"};